/* eslint-disable no-console */
/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT,AUTH_SUCCESS_FIRST } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import { apiClient } from "@/utils/apiClient";
import Axios from "axios";

const state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false }

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  token: state => state.token,
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      apiClient
        .post("/api/auth/signin", {
          username: user.username,
          password: user.password,
          fa2:user.fa2
        })
        .then(response => {
          console.log(response);

          //localStorage.setItem('user-token', response.accessToken)
          // Here set the header of your ajax library to the token value.
          // example with axios
          // axios.defaults.headers.common["Authorization"] = response.token;

          //

          //สำหรับทดสอบ ให้ไปหน้า change password
          // response.data.respJson = {statusCode:"0",forceChangePassword:"Y"}

          if(response.data!==null){
            let respJson = response.data;
 

            if(respJson.statusCode==="0000"&&respJson.forceChangePassword==="Y"){//ให้ไปเปลี่ยน password ก่อน

              localStorage.setItem('user-token', response.data.accessToken)
              localStorage.setItem('user-name', response.data.name)
              localStorage.setItem('taxId', response.data.taxId)
    
              Axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.accessToken}` 
    
              commit(AUTH_SUCCESS_FIRST, response)
              dispatch(USER_REQUEST)
              resolve(response)


            }else if(respJson.statusCode==="0000"||(respJson.accessToken!==null&&respJson.accessToken!=="")){// Login success
              localStorage.setItem('user-token', response.data.accessToken)
              localStorage.setItem('user-name', response.data.name)
              localStorage.setItem('taxId', response.data.taxId)
    
              Axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.accessToken}` 
    
              commit(AUTH_SUCCESS, response)
              dispatch(USER_REQUEST)
              resolve(response);

            }else{
              
              // reject(err);
              reject({name:respJson.statusCode,message:respJson.statusDesc})
            }
          }

          // localStorage.setItem('user-token', response.data.accessToken)
          // localStorage.setItem('user-name', response.data.name)

          // Axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.accessToken}` 

          // commit(AUTH_SUCCESS, response)
          // dispatch(USER_REQUEST)
          // resolve(response)

        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          localStorage.removeItem('user-name')
          reject(err)
        });


    })
  },
  [AUTH_LOGOUT]: ({commit}) => {
    return new Promise((resolve) => {

      apiClient.get("/api/auth/signOut")
      .then(resp => {

        commit(AUTH_LOGOUT)
        localStorage.removeItem('user-token')
        localStorage.removeItem('user-name')
        localStorage.removeItem('beneTaxId')
        localStorage.removeItem('beneGroup')
        localStorage.removeItem('beneName')
  
        localStorage.removeItem('registerVerifyId')
        localStorage.removeItem('taxId')
        resolve();
      }).catch(error => {
        if (error.response) {
          if(error.response.status===401){
            // ถ้าเป็น 401 แสดงว่า session timeout แล้วไม่ได้ต้องทำอะไร

          }else{
            this.$swal("Error!", "ไม่สามารถ Signout ได้ ", "error");          
          }
        }
      });



    });
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.data.accessToken
    state.hasLoadedOnce = true
  },
  [AUTH_SUCCESS_FIRST]: (state, resp) => {
    state.status = 'successFirst'
    state.token = resp.data.accessToken
    state.hasLoadedOnce = true
  },  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
